import { Collapse } from "antd"
import { useState } from "react";
import { MedicalDetailsContent } from "./MedicalDetailsContent";
import { RoutineDiet } from "./RoutineDiet";
import '../style/MedicalDetails.scss'

export const MedicalDetails = (props) => {
    const { Panel } = Collapse;
    // which sections are open: saving Medical Data opens Routine Diet, saving Routine Diet moves to the next tab
    const [open, setOpen] = useState({ medical: false, routine: false })

    // only one section open at a time: opening one closes the other (closed sections keep what was typed)
    const toggle = (section) => (keys) => {
        const opened = [].concat(keys).length > 0
        setOpen(opened ? { medical: section === 'medical', routine: section === 'routine' } : (current) => ({ ...current, [section]: false }))
    }

    const onMedicalSaved = () => {
        setOpen({ medical: false, routine: true })
        setTimeout(() => document.querySelector('.MedicalDetails .routine-diet-panel')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 300)
    }

    return (

        <div className="MedicalDetails">
            <Collapse
                expandIconPosition="end"
                //   key={index}
                className="mt-1"
                activeKey={open.medical ? ['1'] : []}
                onChange={toggle('medical')}
            >
                <Panel header="Medical Data" key="1">
                    <MedicalDetailsContent onSaved={onMedicalSaved} />
                </Panel>
            </Collapse>
            <Collapse
                expandIconPosition="end"
                //   key={index}
                className="mt-1 routine-diet-panel"
                activeKey={open.routine ? ['2'] : []}
                onChange={toggle('routine')}
            >
                <Panel header="Routine Diet" key="2">
                <RoutineDiet onSaved={props.onSaved} />
                </Panel>
            </Collapse>
        </div>
    )
}
